import React from 'react';

import EasyCreditRedirect from 'Modules/easyCredit/routes/EasyCreditRedirect';
import { Error } from 'Modules/core/routes/Error';
import ApplicationNotFound from 'Modules/easyCredit/routes/ApplicationNotFound';

export const easyCreditRedirectPath = '/easy-credit';
export const easyCreditErrorPath = '/easy-credit/error';
export const applicationNotFoundPath = '/easy-credit/not-found';

export const routes = [
    { path: easyCreditRedirectPath, element: <EasyCreditRedirect /> },
    { path: easyCreditErrorPath, element: <Error /> },
    { path: applicationNotFoundPath, element: <ApplicationNotFound /> },
];
